import grey from '@material-ui/core/colors/grey';
import { JUDGEMENT_STATUS } from '~/common/constants';
import { SURVEY_STATUSES } from '~/constants';

export const SPACING = 4;
export const WEB_FONT_FAMILY = 'Noto Sans JP';
export const BASE_FONT_FAMILY = `${WEB_FONT_FAMILY}, Lucida Grande, ＭＳ Ｐゴシック, MS PGothic, ヒラギノ角ゴProN W3, Hiragino Kaku Gothic ProN, Arial, Helvetica, Verdana, sans-serif`;

export const FONT_SIZES_NUM = {
  base: 62.5,
  title1: 2.0,
  title2: 1.6,
  title3: 1.4,
  title4: 1.3,
  title5: 1.2,
  bodyDefault: 1.6,
  body1: 2.0,
  body2: 1.5,
  body3: 1.4,
  body4: 1.3,
  body5: 2.4,
  modalInputDefault: 1.8,
  tableBody1: 1.8,
  note1: 1.2,
  note2: 1.1,
  note3: 1.0,
};

export const FONT_SIZES = {
  base: `${FONT_SIZES_NUM.base}%`,
  title1: `${FONT_SIZES_NUM.title1}rem`,
  title2: `${FONT_SIZES_NUM.title2}rem`,
  title3: `${FONT_SIZES_NUM.title3}rem`,
  title4: `${FONT_SIZES_NUM.title4}rem`,
  title5: `${FONT_SIZES_NUM.title5}rem`,
  bodyDefault: `${FONT_SIZES_NUM.bodyDefault}rem`,
  body1: `${FONT_SIZES_NUM.body1}rem`,
  body2: `${FONT_SIZES_NUM.body2}rem`,
  body3: `${FONT_SIZES_NUM.body3}rem`,
  body4: `${FONT_SIZES_NUM.body4}rem`,
  body5: `${FONT_SIZES_NUM.body5}rem`,
  modalInputDefault: `${FONT_SIZES_NUM.modalInputDefault}rem`,
  tableBody1: `${FONT_SIZES_NUM.tableBody1}rem`,
  note1: `${FONT_SIZES_NUM.note1}rem`,
  note2: `${FONT_SIZES_NUM.note2}rem`,
  note3: `${FONT_SIZES_NUM.note3}rem`,
};
export const FONT_WEIGHTS = {
  base: 400,
  size1: 700,
  size2: 600,
  size3: 500,
};

export const BASE_FONT_COLOR = '#022B4D';

export const TYPOGRAPHY = {
  fontFamily: BASE_FONT_FAMILY,
  title1: { fontSize: FONT_SIZES.title1 },
  title2: { fontSize: FONT_SIZES.title2 },
  title3: { fontSize: FONT_SIZES.title3 },
  title4: { fontSize: FONT_SIZES.title4 },
  title5: { fontSize: FONT_SIZES.title5 },
  bodyDefault: { fontSize: FONT_SIZES.bodyDefault },
  body1: { fontSize: FONT_SIZES.body1 },
  body2: { fontSize: FONT_SIZES.body2 },
  body3: { fontSize: FONT_SIZES.body3 },
  body4: { fontSize: FONT_SIZES.body4 },
  body5: { fontSize: FONT_SIZES.body5 },
  modalInputDefault: { fontSize: FONT_SIZES.modalInputDefault },
  tableBody1: { fontSize: FONT_SIZES.tableBody1 },
  note1: { fontSize: FONT_SIZES.note1 },
  note2: { fontSize: FONT_SIZES.note2 },
  note3: { fontSize: FONT_SIZES.note3 },
};

export const Z_INDEX = {
  max: 9999,
  modal: { overlay: 300 },
  toast: 200,
  loadingIcon: 100,
  header: 99,
  tooltip: 50,
  base: 1,
  minus: -1,
};

export const PALETTE = {
  primary: {
    superLight: '#EDF6FF',
    main: '#4AA7F7',
    subButton: '#C1E1FB',
  },
  secondary: {
    main: '#1976d2',
    subButton: '#F4F9FD',
  },
  info: {
    main: '#fff',
  },
  error: {
    light: '#ffefef',
    main: '#E33F3F',
    blue: '#4AA7F7',
  },
  warning: {
    light: '#FFF1E0',
    main: '#FF9A24',
    red: '#E26666',
  },
  cancel: {
    sub: '#8795A5',
  },
  gray: {
    50: grey[50],
    100: '#E7EFF4',
    200: '#a7a7a7e2',
    300: '#84919A',
    400: '#B2BDC5',
    500: '#73899C',
    600: grey[600],
    700: grey[700],
    800: grey[800],
  },
  yellow: {
    main: '#fed226',
    dark: '#FDD600',
  },
  blue: {
    dark: '#005BAC',
    main: '#F4F8FC',
    light: '#FAFBFC',
    note: '#dfeefd',
    aisupport: '#67DCEF',
  },
  white: '#fff',
  black: '#000',
  navy: {
    main: '#0C3454',
  },
  bg: {
    main: '#fafbfc',
    light: '#E5F7FF',
    lightBlue: '#e2f1fe',
  },
  border: {
    frame: '#C6D5DC',
    table: '#cddae6',
    modalItemBottom: '#D4DDDE',
    input: '#d9e9f0',
    inputBorderBottom: '#dfe8ec',
    shadow: '#00000015',
    error: '#DF4445',
    blueDark: '#2B4D6A',
    bluePale: '#CEDAE0',
  },
  text: {
    main: '#022B4D',
    primary: '#0084F7',
    sub: '#425F77',
    area: '#032b4d',
    darkBlue: '#2b4d6a',
  },
};

export const ADMIN_PALETTE = {
  primary: {
    main: '#4AA7F7',
  },
  secondary: {
    main: '#022B4D',
  },
};

export const SHADOW = {
  100: '0px 2px 6px #0000000A',
  200: '0px 2px 2px #00000029',
};

export const HEADER = {
  headerBar: {
    height: '66px',
  },
  navigationBar: {
    height: '66px',
    bgColor: {
      user: '#005BAC',
      admin: '#E5F1FB',
    },
    logoutButtonColor: {
      user: '#fff',
      admin: '#4AA7F7',
    },
  },
};

export const BUTTON = {
  roundedBorder: {
    radius: '16px',
  },
  squareRoundBorder: {
    radius: '4px',
  },
  dragIcon: {
    active: '#4AA7F7',
    unactive: '#AFB9C0',
  },
};

export const SURVEY_STATUS_COLORS = {
  [SURVEY_STATUSES.REGISTERING]: '#022b4d', // 下書き
  [SURVEY_STATUSES.UNDER_REVIEW]: '#0080C4', // 審査中
  [SURVEY_STATUSES.APPROVED]: '#f8A200', // 配信待ち
  [SURVEY_STATUSES.COLLECTING]: '#4AA7F7', // 回答中
  [SURVEY_STATUSES.COMPLETED]: '#abb5bc', // 完了
  [SURVEY_STATUSES.REJECTED]: '#E33F3F', // 審査NG
  [SURVEY_STATUSES.CANCELED]: '#F5F6F8', // キャンセル
};

export const JUDGEMENT_STATUS_COLORS = {
  [JUDGEMENT_STATUS.UNTOUCHED]: '#062F50', // 未
  [JUDGEMENT_STATUS.OK]: '#0080C4', // OK
  [JUDGEMENT_STATUS.NG]: '#E33F3F', // NG
  [JUDGEMENT_STATUS.UNNEEDED]: '#8095A6', // 不
};
